// Single shared Supabase client for the whole app.
//
// URL + anon key come from .env.local (REACT_APP_*) and must also be set on
// Vercel project env vars for deployments. The anon key is safe to expose
// in the browser bundle — row-level security on the server is what actually
// enforces access. The service_role key is NEVER added here.

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Throw at module load so misconfiguration fails loudly rather than at
  // first auth call. Catch this in dev with a clear .env.local message.
  throw new Error(
    'Supabase env vars missing. Set REACT_APP_SUPABASE_URL and ' +
    'REACT_APP_SUPABASE_ANON_KEY in .env.local (and on Vercel).'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  // PERF FIX 2026-07-14: default Realtime rate is 10 events/sec per
  // channel, at which point Supabase silently drops overflow. Busy
  // tenants running the Live Operations Floor + Inbox + AI-activity
  // channels simultaneously can hit this cap on a spike (a drip fires
  // 40 SMS in a batch, cron scan emits per-owner rows, etc.). 50/s
  // gives comfortable headroom for the current employee count without
  // hitting Supabase's plan-tier ceilings.
  realtime: { params: { eventsPerSecond: 50 } },
});
